import script from "./DesignFormModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DesignFormModal.vue?vue&type=script&setup=true&lang=js"

import "./DesignFormModal.vue?vue&type=style&index=0&id=0bf50b78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bf50b78"]])

export default __exports__